// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"ecd60254","423":"67877590","424":"17243425","627":"ef57ad7d"}[chunkId] + ".chunk.js";
};